var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8951 9.35873C17.8951 13.3 11.9109 20.8437 9.78857 23.3951C9.40145 23.8605 8.70464 23.8605 8.31752 23.3951C6.19516 20.8437 0.210938 13.3 0.210938 9.35873C0.210938 4.56792 4.16968 0.684204 9.05304 0.684204C13.9364 0.684204 17.8951 4.56792 17.8951 9.35873Z",
    fill: "#667F91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressFrom);
export default __webpack_public_path__ + "static/media/AddressFrom.10b0e34a645b8b993bbe523b90a8e865.svg";
export { ForwardRef as ReactComponent };